<span *ngIf="producer != ''"  class="opacity-80">{{producer}}</span><span>{{code}}</span>
